import { render, staticRenderFns } from "./TownPOIOverview.vue?vue&type=template&id=24a6c9e0&scoped=true&"
import script from "./TownPOIOverview.vue?vue&type=script&lang=js&"
export * from "./TownPOIOverview.vue?vue&type=script&lang=js&"
import style0 from "./TownPOIOverview.vue?vue&type=style&index=0&id=24a6c9e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a6c9e0",
  null
  
)

export default component.exports